module.exports = __webpack_public_path__ + "static/media/coming-soon.7218c8e3.svg";